import useOnlineStatus from '../lib/useOnlineStatus'

export default function OfflineGuard({ children, fallbackStyle = {} }) {
  const isOnline = useOnlineStatus()
  
  if (isOnline) return children

  return (
    <div style={{ 
      opacity: 0.3, 
      pointerEvents: 'none', 
      position: 'relative',
      ...fallbackStyle 
    }}>
      {children}
      <div style={{
        position: 'absolute',
        top: 0, left: 0, right: 0, bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <span style={{ 
          fontSize: '10px', 
          color: '#ff6a3d', 
          letterSpacing: '0.12em',
          textTransform: 'uppercase',
          fontFamily: "'Rajdhani', sans-serif",
        }}>
          OFFLINE
        </span>
      </div>
    </div>
  )
}